import React, { useEffect, useContext, useState } from 'react'
import { GridItem } from '@zuto/core/src/grid'
import MuiSelect from '@zuto/atoms/src/Mui/Select/MuiSelect'
import {
  scrollToTheTop,
  questionFontStyle,
  fireReactGAEvent
} from '../../utils'
import QuestionKey from '../../../../Questions/question-key'
import AppFormQuestion from '../../../AppFormQuestion'
import employmentStatusOptionsProminentColourScheme from '../EmploymentStatus/EmploymentStatusOptionsProminentColourScheme'
import withFade from '../../../HOC/withFade'
import EmploymentHistoryEntryContext from '../EmploymentEntry/EmploymentHistoryEntryContext'

import { HistoryIndex } from '../../HistoryEntry/HistoryEntry'

interface EmploymentStatusProps {
  entryId: HistoryIndex
  existingSituation?: string
}

const EmploymentStatusDropdown = ({
  existingSituation,
  entryId
}: EmploymentStatusProps) => {
    const { dispatch } = useContext(EmploymentHistoryEntryContext)
    const [currentAnswer, setCurrentAnswer] = useState<string | undefined>(
        existingSituation ?? 'full time permanent'
    )

    useEffect(() => {
        if (currentAnswer) {
            dispatch({
                type: 'UPDATE_STATUS',
                value: currentAnswer
            })
            fireReactGAEvent({
                category: 'Application Form',
                action: 'Input',
                label: `EmploymentStatusDropdown: "${currentAnswer}", existingSituation: ${!!existingSituation}, entry: ${entryId}`
            })
        }
    }, [currentAnswer])

  useEffect(scrollToTheTop, [])

  return (
    <>
      <AppFormQuestion
        questionKey={`${QuestionKey.EMPLOYMENT_HISTORY}.situation`}
        mt={3}
        textStyle={questionFontStyle}
      >
        {`Can you tell us about your ${entryId !== '1' ? 'previous ' : ''}employment?`}
      </AppFormQuestion>
      <GridItem gridColumn="1 / span 12" style={{ overflow: 'hidden' }} mt={3} mb={3}>
        <MuiSelect
          aria-label="label-employment-status"
          data={employmentStatusOptionsProminentColourScheme.filter((item) => item.label !== 'Select status')}
          id="employment-status-list"
          label="Employment Status"
          name="employment-status-list"
          onChangeHandler={(e) => setCurrentAnswer(e.target.value)}
          testId="employment-status-dropdown"
          variant="outlined"
          value={currentAnswer}
        />
      </GridItem>
    </>
  )
}

export default withFade(EmploymentStatusDropdown)